<template>
    <section class="article">
        <div class="con_wrap" style="width: 100%; display: flex; flex-direction: column; justify-content: center; padding-top: 115px">
            <div style="display: flex; justify-content: center; align-items: flex-end; margin-bottom: 43px">
                <p data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 36px; font-weight: 700; color: white; text-align: center; color: #000000; line-height: 1">
                    보도자료
                </p>
            </div>
            <div class="postBox" data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" v-for="(item, index) in list.slice(activePage, (activePage + 5))" :key="index" style="border-bottom: 1px solid #E7E7E7; padding: 20px 0">
                <div style="display: flex; justify-content: space-between;">
                    <div style="display: flex">
                        <p style="font-size: 20px; color: black; font-weight: 700; margin-bottom: 10px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1; overflow: hidden;">{{item.title}}</p>
                        <p></p>
                    </div>
                    <div style="display: flex">
                        <p style="font-size: 15px; color: #CCCCCC; font-weight: 400; margin-bottom: 10px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1; overflow: hidden;">{{item.date}}</p>
                        <p></p>
                    </div>
                </div>
                <p style="font-size: 20px; color: #737373; font-weight: 400; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;">{{item.detail}}</p>
            </div>
            <div class="listCount" style="display: flex; justify-content: center; align-items: center; margin: 133px auto; font-size: 18px">
                <p @click="prev()" class="inactiveBtn" :class="{activeBtn: activePage > 0}" style="cursor: pointer">이전</p>
                <div style="width: 280px; margin: 0">
                    <div v-if="allCount < 5" style="display: flex; justify-content: center; align-items: center;">
                        <!-- Math.floor(activeIndex % 3) * 3, ((Math.floor(activeIndex % 3) * 3) + 3)) -->
                        <p class="inactiveNumber" :class="{activeNumber: activePage == index}" @click="activePage = index" v-for="(item, index) in allCount" :key="index" style="margin: 0 12.5px; cursor: pointer">{{index + 1}}</p>
                    </div>
                    <div v-else style="display: flex; justify-content: center; align-items: center;">
                        <!-- Math.floor(activeIndex % 3) * 3, ((Math.floor(activeIndex % 3) * 3) + 3)) -->
                        <p class="inactiveNumber" :class="{activeNumber: activePage == index}" @click="activePage = index" v-for="(item, index) in allCount" :key="index" style="cursor: pointer">
                            <span v-if="(index == 0) || (index >= (Math.floor(activePage / 5) * 5) && index < ((Math.floor(activePage / 5) + 1) * 5))" style="margin: 0 12.5px;">{{item}}</span>
                            <span v-if="index == 2 && (Math.floor(activePage / 5) * 5) != 0">..</span>
                        </p>
                    </div>
                </div>
                <p @click="next()" class="inactiveBtn" :class="{activeBtn: activePage < allCount - 1}" style="cursor: pointer">다음</p>
            </div>
        </div>
        <Footer id="footer" />
    </section>
</template>
<script>
import Footer from './Footer.vue'
export default {
    components: {
        Footer
    },
    data() {
        return {
            list: [],
            allCount: 0,
            activePage: 0,
            topBtn: false
        }
    },
    watch: {
        scrollY() {
            this.topBtn = this.scrollY != 0 ? true : false
        }
    },
    computed: {
        postList() {
            return this.$store.state.postList
        }
    },
    methods: {
        prev() {
            if(this.activePage > 0) {
                this.activePage--
            }
        },
        next() {
            if(this.activePage < this.allCount - 1) {
                this.activePage++
            }
        }
    },
    created() {
        this.list = []
        for(var j in this.postList) {
            this.list.push(JSON.parse(JSON.stringify(this.postList))[j])
        }
        this.allCount = Math.ceil(this.list.length / 5)
        console.log(this.allCount)
    }
}
</script>
<style>
    .article .con_wrap {
        width: 100%;
        max-width: 1180px;
        margin: 0 auto;
    }
    .article .postBox:hover {
        cursor:pointer;
        background: #CECECE;
    }
    .article .inactiveNumber {
        font-weight: 400;
        color: #737373
    }
    .article .activeNumber {
        font-weight: 700;
        color: black
    }
    .article .inactiveBtn {
        font-weight: 400;
        color: #CCCCCC
    }
    .article .activeBtn {
        color: black
    }
</style>